const FILE_PICK_STEP = 0;
const MUTE_EXCLUDE_STEP = 1;
const VIDEO_DURATION_STEP = 2;
const IMAGE_GENERATION_STEP = 3;
const VOICE_NARRATION_STEP = 4;
const GENERATE_MICROLESSON_STEP = 5;
const AI_ASSISTANT_STEP = 6;
const SUMMARY_STEP = 7;

const videoGenerationSteps = [
  {
    id: FILE_PICK_STEP,
    title: 'Upload',
  },
  {
    id: MUTE_EXCLUDE_STEP,
    title: 'Exceptions',
  },
  {
    id: VIDEO_DURATION_STEP,
    title: 'Video duration',
  },
  {
    id: IMAGE_GENERATION_STEP,
    title: 'AI media',
  },
  {
    id: VOICE_NARRATION_STEP,
    title: 'Narration',
  },
  {
    id: GENERATE_MICROLESSON_STEP,
    title: 'Microlesson',
  },
  {
    id: AI_ASSISTANT_STEP,
    title: 'AI assistant',
  },
  {
    id: SUMMARY_STEP,
    title: 'Summary',
  },
];

export {
  FILE_PICK_STEP,
  MUTE_EXCLUDE_STEP,
  VIDEO_DURATION_STEP,
  VOICE_NARRATION_STEP,
  IMAGE_GENERATION_STEP,
  GENERATE_MICROLESSON_STEP,
  AI_ASSISTANT_STEP,
  SUMMARY_STEP,
  videoGenerationSteps,
};
